var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4379 14.4654H15.3991L15.0309 14.1103C16.3197 12.6112 17.0955 10.6649 17.0955 8.5477C17.0955 3.82676 13.2687 0 8.5477 0C3.82676 0 0 3.82676 0 8.5477C0 13.2687 3.82676 17.0955 8.5477 17.0955C10.6649 17.0955 12.6112 16.3197 14.1103 15.0309L14.4654 15.3991V16.4379L21.0406 23L23 21.0406L16.4379 14.4654ZM8.5477 14.4654C5.2733 14.4654 2.63007 11.8222 2.63007 8.5477C2.63007 5.2733 5.2733 2.63007 8.5477 2.63007C11.8222 2.63007 14.4654 5.2733 14.4654 8.5477C14.4654 11.8222 11.8222 14.4654 8.5477 14.4654Z",
    fill: "#5B21FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.8f893bc47b7ba830ca21a3bf7f3323f1.svg";
export { ForwardRef as ReactComponent };